import React from "react";

interface ButtonProps {
  text: string;
  style?: React.CSSProperties;
  className?: string;
  leftIcon?: string;
  rightIcon?: string;
  onClick?: () => void;
}

export const GradientButton: React.FC<ButtonProps> = ({ text, style, leftIcon, rightIcon, onClick, className }) => (
  <button 
    className={`inline-flex justify-center items-center w-[169px] h-[38px] gap-[10px] rounded-full py-1 px-4 bg-gradient-to-r from-[#8B3730] to-[#E15142] text-white font-bold my-auto ${className}`} 
    style={style} 
    onClick={onClick}
  >
    {leftIcon && <div className="rounded-full w-4 h-4 bg-white text-[#0070CD] flex items-center justify-center text-base"><h3 className="w-full h-full flex items-center justify-center text-base">{leftIcon}</h3></div>}
    {text}
    {rightIcon && <div className="rounded-full w-4 h-4 bg-white text-[#0070CD] flex items-center justify-center text-base"><h3 className="w-full h-full flex items-center justify-center text-base">{rightIcon}</h3></div>}
  </button>
);
